import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./TableRow.css";
import useEventOddsSocket from "../../hooks/useEventOddsSocket";

const TableRow = ({ i, row, isMobile, username, enableOddsSocket = true }) => {
  const navigate = useNavigate();
  const [isFavourite, setIsFavourite] = useState(false);

  const toggleFavourite = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsFavourite((previousValue) => !previousValue);
  };

  const socketUsername =
    username !== undefined &&
    username !== null &&
    String(username).trim() !== ""
      ? String(username)
      : "guest";

  const liveMarket = useEventOddsSocket(
    row?.event_id,
    socketUsername,
    enableOddsSocket,
  );
  // if (liveMarket) {
  //   console.log("LIVE MARKET:", row?.event_id, liveMarket);
  // }
  const getMatchDateTime = () => {
    if (!row?.open_date) return "";

    const date = new Date(row.open_date);

    if (Number.isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year}, ${hours}:${minutes}`;
  };

  // ==================== DYNAMIC ODDS LOGIC (REVISED & ROBUST) ====================
  // const placeholderOdd = {
  //   price: "0",
  //   size: "",
  // };

  // const liveMarketTypes =
  //   liveMarket?.market_types || liveMarket?.marketTypes || [];

  // const matchOddsMarket = liveMarketTypes.find((market) => {
  //   const marketName = String(market?.market_name || market?.marketName || "")
  //     .trim()
  //     .toLowerCase();

  //   return marketName === "match odds" || marketName === "match_odds";
  // });

  // const marketRunners =
  //   matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // const backOdds = [];
  // const layOdds = [];

  // for (let index = 0; index < 3; index++) {
  //   const runner = marketRunners[index];

  //   if (!runner) {
  //     backOdds.push({
  //       ...placeholderOdd,
  //     });

  //     layOdds.push({
  //       ...placeholderOdd,
  //     });

  //     continue;
  //   }

  //   backOdds.push({
  //     price: runner.back_1_price ?? runner.backPrice ?? "0",

  //     size: runner.back_1_size ?? runner.backSize ?? "",
  //   });

  //   layOdds.push({
  //     price: runner.lay_1_price ?? runner.layPrice ?? "0",

  //     size: runner.lay_1_size ?? runner.laySize ?? "",
  //   });
  // }

  // const odds = [...backOdds, ...layOdds];
  // ==============================================================================

  // ==================== SIX MARKET-DEPTH ODDS ====================
  const liveMarketTypes =
    liveMarket?.market_types || liveMarket?.marketTypes || [];

  const isLive =
    row?.is_inplay === true ||
    row?.is_inplay === 1 ||
    row?.is_inplay === "1" ||
    String(row?.is_inplay).toLowerCase() === "true";

  const matchOddsMarket = liveMarketTypes.find((market) => {
    const marketName = String(market?.market_name || market?.marketName || "")
      .trim()
      .toLowerCase();

    return marketName === "match odds" || marketName === "match_odds";
  });

  const marketRunners =
    matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // Single UpcomingEvents row mein
  // first runner ka complete depth.
  const formatOdd = (value) => {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      Number(value) === 0
    ) {
      return "-";
    }

    return value;
  };

  /*
   * Cricket/2-runner market:
   *
   * 1 = first runner
   * X = empty
   * 2 = second runner
   *
   * 3-runner market:
   *
   * 1 = first runner
   * X = second runner
   * 2 = third runner
   */
  const outcomeRunners =
    marketRunners.length === 2
      ? [marketRunners[0], null, marketRunners[1]]
      : [
          marketRunners[0] || null,
          marketRunners[1] || null,
          marketRunners[2] || null,
        ];

  const outcomeLabels = ["1", "X", "2"];

  const outcomes = outcomeLabels.map((label, index) => {
    const runner = outcomeRunners[index];

    return {
      label,

      back: {
        price: runner
          ? formatOdd(runner?.back_1_price ?? runner?.backPrice)
          : "-",

        size: runner ? (runner?.back_1_size ?? runner?.backSize ?? "") : "",
      },

      lay: {
        price: runner
          ? formatOdd(runner?.lay_1_price ?? runner?.layPrice)
          : "-",

        size: runner ? (runner?.lay_1_size ?? runner?.laySize ?? "") : "",
      },
    };
  });
  // ==============================================================

  const teamNames = row?.event_name?.split(" v ") || ["Team A", "Team B"];
  // const linkTo = `/matchupdates/${row.event_id}/${row.is_inplay === "True" ? "Inplay" : "Going Inplay"}`;
  const linkTo = `/matchupdates/${row.event_id}/${
    isLive ? "Inplay" : "Going Inplay"
  }`;

  const openMatchUpdates = (event) => {
    console.log("MATCH ROW CLICKED:", linkTo);


    event.preventDefault();
    event.stopPropagation();

    const eventId = row?.event_id;

    if (!eventId) {
      console.error("MatchUpdates: Event ID missing", row);
      return;
    }

    const matchStatus = isLive ? "Inplay" : "Going%20Inplay";

    navigate(`/matchupdates/${eventId}/${matchStatus}`, {
      replace: false,
    });
  };

  const mobileSportImage =
    {
      1: "1.png",
      2: "2.png",
      4: "4.png",
    }[Number(row?.event_type)] || "4.png";

  if (isMobile) {
    const mobileOdds = outcomes.flatMap((outcome) => [
      outcome.back,
      outcome.lay,
    ]);

    return (
      <Link
        to={linkTo}
        className="reference-mobile-event-link"
        onClick={openMatchUpdates}
      >
        <article className="reference-mobile-event">
          <div className="reference-mobile-event-info">
            <span className="reference-mobile-sport-icon">
              <img
                src={`${process.env.PUBLIC_URL}/Images/navigation-images/${mobileSportImage}`}
                alt=""
              />
            </span>

            <div className="reference-mobile-event-content">
              <div className="reference-mobile-event-details">
                <div className="reference-mobile-event-name">
                  <span className="reference-mobile-event-name-text">
                    {row.event_name}
                  </span>

                  {isLive && <span className="reference-mobile-live-dot" />}
                </div>

                <div className="reference-mobile-event-date">
                  {getMatchDateTime()}
                </div>
              </div>

              <div className="reference-mobile-event-actions">
                <img
                  src={`${process.env.PUBLIC_URL}/Images/tv.svg`}
                  alt="Live stream"
                  className="reference-mobile-tv"
                />

                {row.is_fancy === "True" && (
                  <span className="reference-mobile-badge">F</span>
                )}

                <span className="reference-mobile-badge">BM</span>
                <span className="reference-mobile-star">☆</span>
              </div>
            </div>
          </div>

          <div className="reference-mobile-odds">
            {mobileOdds.map((odd, index) => (
              <div
                key={`${row.event_id}-odd-${index}`}
                className={[
                  "reference-mobile-odd",
                  index % 2 === 0
                    ? "reference-mobile-odd-back"
                    : "reference-mobile-odd-lay",
                ].join(" ")}
              >
                {odd?.price ?? "-"}
              </div>
            ))}
          </div>
        </article>
      </Link>
    );
  }

  if (!isMobile) {
    return (
      <Link
        to={linkTo}
        className="desktop-event-link"
        onClick={openMatchUpdates}
      >
        <article className="desktop-event-row">
          {/* Event name and date */}

          <div className="desktop-event-main">
            <div className="desktop-event-information">
              <button
                type="button"
                className="desktop-favourite-star"
                onClick={toggleFavourite}
                aria-label={
                  isFavourite ? "Remove from favourites" : "Add to favourites"
                }
              >
                <img
                  src={
                    isFavourite
                      ? `${process.env.PUBLIC_URL}/Images/star-red-active.png`
                      : `${process.env.PUBLIC_URL}/Images/star-red-inactive.png`
                  }
                  alt=""
                />
              </button>

              <div className="desktop-event-details">
                <span className="desktop-event-date">{getMatchDateTime()}</span>

                <span className="desktop-event-name">
                  {row?.event_name || "Event"}
                </span>
              </div>
            </div>

            <div className="desktop-event-icons">
              {isLive && (
                <span
                  className="desktop-live-dot"
                  title="Live"
                  aria-label="Live"
                />
              )}

              <img
                src={`${process.env.PUBLIC_URL}/Images/tv.svg`}
                alt="Live streaming"
                title="Live streaming"
                className="desktop-tv-icon"
              />

              <span className="desktop-market-badge desktop-fancy-badge">
                F
              </span>

              <span className="desktop-market-badge desktop-bm-badge">BM</span>

              {(row?.event_type === 1 || row?.event_type === "1") && (
                <span
                  className="desktop-gamepad-icon"
                  title="Game"
                  aria-label="Game"
                >
                  <i className="fas fa-gamepad" aria-hidden="true" />
                </span>
              )}
            </div>
          </div>

          {/* 1, X and 2 back/lay odds */}
          {outcomes.map((outcome) => (
            <React.Fragment key={outcome.label}>
              <div
                className={[
                  "desktop-odd",
                  "desktop-back-odd",
                  outcome.back.price === "-" ? "desktop-odd-disabled" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <strong>{outcome.back.price}</strong>

                <small>
                  {outcome.back.size !== "" && outcome.back.price !== "-"
                    ? outcome.back.size
                    : "-"}
                </small>
              </div>

              <div
                className={[
                  "desktop-odd",
                  "desktop-lay-odd",
                  outcome.lay.price === "-" ? "desktop-odd-disabled" : "",
                ]
                  .filter(Boolean)
                  .join(" ")}
              >
                <strong>{outcome.lay.price}</strong>

                <small>
                  {outcome.lay.size !== "" && outcome.lay.price !== "-"
                    ? outcome.lay.size
                    : "-"}
                </small>
              </div>
            </React.Fragment>
          ))}
        </article>
      </Link>
    );
  }

  return (
    <Link to={linkTo} className="reference-event-link">
      <article className="reference-event-row">
        {/* Row 1: Event name and available markets */}
        <div className="reference-event-heading">
          <span className="reference-event-name">
            {row?.event_name || "Event"}
          </span>

          <div className="reference-event-icons">
            {isLive && (
              <span
                className="reference-live-dot"
                title="Live"
                aria-label="Live"
              />
            )}

            <span className="reference-tv-icon" title="Live streaming">
              <i className="d-icon icon-tv" aria-hidden="true" />
            </span>

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_fancy.webp`}
              alt="Fancy"
              className="reference-market-icon reference-fancy-icon"
            />

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_bm.webp`}
              alt="Bookmaker"
              className="reference-market-icon reference-bm-icon"
            />

            {(row?.event_type === 1 || row?.event_type === "1") && (
              <span className="reference-gamepad-icon" aria-label="Game">
                ♣
              </span>
            )}
          </div>
        </div>

        {/* Row 2: Date and outcome headings */}
        <div className="reference-event-meta">
          <span className="reference-event-date">{getMatchDateTime()}</span>

          <div className="reference-outcome-headings">
            {outcomes.map((outcome) => (
              <span key={outcome.label}>{outcome.label}</span>
            ))}
          </div>
        </div>

        {/* Row 3: Back/Lay odds */}
        <div className="reference-event-odds">
          {outcomes.map((outcome) => (
            <React.Fragment key={outcome.label}>
              <div className="reference-odd reference-back-odd">
                <strong>{outcome.back.price}</strong>

                {/* {outcome.back.size !== "" &&
                  outcome.back.price !== "-" && (
                    <small>{outcome.back.size}</small>
                  )} */}
              </div>

              <div className="reference-odd reference-lay-odd">
                <strong>{outcome.lay.price}</strong>

                {/* {outcome.lay.size !== "" &&
                  outcome.lay.price !== "-" && (
                    <small>{outcome.lay.size}</small>
                  )} */}
              </div>
            </React.Fragment>
          ))}
        </div>
      </article>
    </Link>
  );
};

export default TableRow;
